module.exports = __webpack_public_path__ + "static/christianwork7-4ea0bd7883288ae88cdabbdde9568a85.jpg";